/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent as F, useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import { useAppDispatch } from "../../core/store/hooks";
import { IState } from "../../core/store/store";
import ControlledAutocomplete from "../UI/Input/ControlledAutocomplete";
import { retrieveCurrenciesAsync } from "../../core/store/listings/listings.thunks";
import { IOption } from "@protoplan/types";


interface Props
{
  initialValue?: number,
  onChangeOption?: (option: IOption | null) => void
  disabled?: boolean
}


const CurrencyDropdown: F<Props> = (props: Props) =>
{
  const appDispatch = useAppDispatch();

  const currencies = useSelector((state: IState) => state.listings.currencies);
  const populatedCurrencyOptions = currencies.map(currency => ({
    value: currency.currencyId,
    label: currency.symbol ? currency.symbol + " (" + currency.code + ")" : currency.code }));

  const mounted = useRef<boolean>();
  useEffect(() =>
  {
    if (!mounted.current)
    {
      mounted.current = true;
      appDispatch(retrieveCurrenciesAsync())
        .then(() =>
        {
          setOptions(populatedCurrencyOptions);
        });
    }
  });

  const [options, setOptions] = useState(populatedCurrencyOptions);
  useEffect(() => setOptions(populatedCurrencyOptions), [currencies]);

  const [currentOption, setCurrentOption] = useState<IOption | null>(null);

  useEffect(() =>
  {
    setCurrentOption(populatedCurrencyOptions.find(o => o.value === props.initialValue) || null);
  }, [options, props.initialValue]);

  const handleChangeOption = (option: IOption | null) =>
  {
    setCurrentOption(option);
    props.onChangeOption && props.onChangeOption(option);
  }

  return (
    <ControlledAutocomplete
      label='Currency*'
      width='150px'
      currentOption={currentOption}
      onChangeCurrentOption={handleChangeOption}
      disableClearable={true}
      disabled={props.disabled}
      options={options}/>);
};


export default CurrencyDropdown;
